export default {
  get (name, defaultObject) {
    const dataJson = localStorage.getItem(name)

    if (dataJson === null || dataJson === 'undefined') {
      return (defaultObject !== 'undefined') ? defaultObject : null
    }

    const object = JSON.parse(dataJson)
    Object.keys(defaultObject).forEach(key => {
      if (!Object.hasOwn(object, key)) {
        object[key] = defaultObject[key]
      }
    })

    return object
  },
  set (name, object) {
    localStorage.setItem(name, JSON.stringify(object))
  }
}
